<template>
  <pre v-if="isDebug">
    {{ debug }}
     <slot></slot>
  </pre>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

import { ConfigModule } from "@/store/modules/config";

/**
 * Shows its content only in debug mode.
 *
 * Plain slot content is still built by the parent on every one of its renders, debug mode or not - `{{ tickets }}`
 * serializes every ticket each time. Wrap it in `<template #default>` to turn it into a scoped slot, which only runs
 * when it is shown.
 */
@Component
export default class Debug extends Vue {
  @Prop({})
  debug: any;

  get isDebug() {
    return ConfigModule.debug;
  }
}
</script>

<style scoped>
pre {
  white-space: pre-wrap;
  overflow-x: auto;
  tab-size: 1;
  background-color: lightgray;
  font-size: 0.7rem;
}
</style>
